exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".SpinnerBox__wrapper__2Qcau.SpinnerBox__overlay__34YMa{top:0;left:0;position:absolute;width:100%;height:100%;background-color:rgba(0,0,0,.1);z-index:10000}.SpinnerBox__wrapper__2Qcau.SpinnerBox__fullScreen__Kkx0e{position:fixed}.SpinnerBox__innerWrapper__2AOxU{height:100%!important}", "", {"version":3,"sources":["/mnt/d/asofts/vvs/cirrus/Cirrus/frontend/src/components/controls/src/components/controls/SpinnerBox.scss"],"names":[],"mappings":"AAEA,uDAEI,MAAM,AACN,OAAO,AACP,kBAAkB,AAClB,WAAW,AACX,YAAY,AACZ,gCAAoC,AACpC,aAAc,CACf,AATH,0DAYI,cAAe,CAChB,AAGH,iCACE,qBAAuB,CACxB","file":"SpinnerBox.scss","sourcesContent":["@import '../../styles/theme.scss';\n\n.wrapper {\n  &.overlay {\n    top: 0;\n    left: 0;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.1);\n    z-index: 10000;\n  }\n\n  &.fullScreen {\n    position: fixed;\n  }\n}\n\n.innerWrapper {\n  height: 100% !important;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"wrapper": "SpinnerBox__wrapper__2Qcau",
	"overlay": "SpinnerBox__overlay__34YMa",
	"fullScreen": "SpinnerBox__fullScreen__Kkx0e",
	"innerWrapper": "SpinnerBox__innerWrapper__2AOxU"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/SpinnerBox.scss
// module id = ./node_modules/css-loader/index.js??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/SpinnerBox.scss
// module chunks = 0